<template>
  <div id="app" :style="AppStyle">
    <keep-alive>
      <router-view/>
    </keep-alive>
    <mu-bottom-nav v-show="isshowbottom" :value.sync="activebar" class="bottom" style="position: absolute;bottom: 0px;width: 100%;">
      <mu-bottom-nav-item value="book" title="预约" icon="favorite" to="/"/>
      <mu-bottom-nav-item value="onlinebook" title="网上展厅" icon="cloud" to="/OnlineBook"/>
      <mu-bottom-nav-item value="login" title="登陆" icon="home" to="/Login"/>
    </mu-bottom-nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      AppStyle: {
        'font-family': '"Avenir", Helvetica, Arial, sans-serif',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        'color': '#2c3e50',
        'height': window.innerHeight + 'px'
      }
    }
  },
  computed: {
    ...mapGetters([
      'activebar',
      'isshowbottom'
    ])
  }
  // watch: {
  //   isshowbottom(val) {
  //     alert(val)
  //     if (val) {
  //       this.BottomStyle.position = 'absolute'
  //     } else {
  //       this.BottomStyle.position = 'static'
  //     }
  //   }
  // }
}
</script>

<style>
.bottom{
  position: absolute;
  bottom: 0px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue